import { render, staticRenderFns } from "./JcCaptcha.vue?vue&type=template&id=54bf5069&scoped=true&"
import script from "./JcCaptcha.vue?vue&type=script&lang=js&"
export * from "./JcCaptcha.vue?vue&type=script&lang=js&"
import style0 from "./JcCaptcha.vue?vue&type=style&index=0&id=54bf5069&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bf5069",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VTextField})
